
    import './styles.scoped.css';
    export default {
  "empty-appear": "awsui_empty-appear_n4qlp_a55kt_153",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_n4qlp_a55kt_1",
  "root": "awsui_root_n4qlp_a55kt_175",
  "empty": "awsui_empty_n4qlp_a55kt_153",
  "row": "awsui_row_n4qlp_a55kt_218",
  "divider": "awsui_divider_n4qlp_a55kt_222",
  "row-control": "awsui_row-control_n4qlp_a55kt_227",
  "field": "awsui_field_n4qlp_a55kt_231",
  "additional-info": "awsui_additional-info_n4qlp_a55kt_235",
  "add-row": "awsui_add-row_n4qlp_a55kt_281",
  "add-button": "awsui_add-button_n4qlp_a55kt_285",
  "remove-button-container": "awsui_remove-button-container_n4qlp_a55kt_289",
  "remove-button-field-padding": "awsui_remove-button-field-padding_n4qlp_a55kt_293",
  "remove-button-own-row": "awsui_remove-button-own-row_n4qlp_a55kt_297",
  "remove-button": "awsui_remove-button_n4qlp_a55kt_289"
};
  